var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"we-search-wrap"},[_c('input',{ref:"searchbox",staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.placeholder,"type":"text"},domProps:{"value":_vm.currentValue},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"blur":function($event){return _vm.$emit('on-blur', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }